import { useEffect } from "react";

/**
 * Provider pour les pages publiques
 * Tailwind est charge globalement dans main.jsx
 * Ce composant nettoie Bootstrap si on vient des pages admin
 */
const TailwindProvider = ({ children }) => {
  useEffect(() => {
    // Nettoyer Bootstrap/admin si on vient de /admin
    document.querySelectorAll('style').forEach(style => {
      const id = style.getAttribute('data-vite-dev-id') || '';
      if (id.includes('bootstrap') || id.includes('admin.scss')) {
        style.remove();
      }
    });
    document.querySelectorAll('link[href*="bootstrap"]').forEach(link => {
      link.remove();
    });
  }, []);

  return children;
};

export default TailwindProvider;
